"use client"

import { PropsWithChildren } from "react"
import { useManageSubscriptionUrl } from "@/api/subscription"
import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export type ManageSubscriptionButtonProps = {
  teamId: string
  teamSlug: string
  successUrl: string
  stripeCustomerId: string
}

export const ManageSubscriptionButton = ({
  teamSlug,
  successUrl,
  stripeCustomerId,
  children,
}: PropsWithChildren<ManageSubscriptionButtonProps>) => {
  const { data, isPending } = useManageSubscriptionUrl({ teamSlug, stripeCustomerId, successUrl })
  return (
    <a
      className={cn(
        "cursor-pointer",
        { "opacity-50 cursor-not-allowed": isPending },
        buttonVariants({ size: "default", variant: "default" }),
      )}
      href={data?.url}
    >
      {children}
    </a>
  )
}
